if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return; 

      this.handleErrorMessage();
      this.cartNotification?.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const formFields = JSON.parse(serializeForm(this.form));
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...formFields,
        sections: this.cartNotification?.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.text().then((text) => ({ ok: response.ok, text })))
        .then(({ ok, text }) => {
          // A 5xx or a non-JSON body (e.g. a bot-protection interstitial page — observed
          // live as a 503 with HTML that made the old response.json() throw and the add
          // silently do nothing) must not vanish without feedback. Verify against
          // cart.js: if the variant actually made it in, re-sync the drawer; otherwise
          // tell the shopper so they can retry.
          let parsed = null;
          try { parsed = JSON.parse(text); } catch (e) { parsed = null; }
          if (!ok || !parsed) {
            return this.verifyAddOrFail(formFields);
          }
          if (parsed.status) {
            this.handleErrorMessage(parsed.description);
            return;
          }

          this.cartNotification.renderContents(parsed);
        })
        .catch(() => {
          // Network-level failure (fetch rejected) — same verify-then-feedback path.
          this.verifyAddOrFail(formFields);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    // The add request failed or returned garbage — but it may still have applied
    // server-side. Check the cart before deciding what to show.
    verifyAddOrFail(formFields) {
      const variantId = parseInt(formFields && formFields.id, 10);
      return fetch(`${window.Shopify.routes.root}cart.js`, { cache: 'no-store' })
        .then((r) => { if (!r.ok) throw new Error('cart fetch failed'); return r.json(); })
        .then((cart) => {
          const inCart = !isNaN(variantId) && (cart.items || []).some((item) => item.variant_id === variantId);
          if (inCart && this.cartNotification) {
            // The add took despite the bad response — re-sync and show the drawer.
            this.cartNotification.refreshCartNotification();
            this.cartNotification.open('add');
            return;
          }
          this.handleErrorMessage("Couldn't add to cart — please try again.");
        })
        .catch(() => {
          this.handleErrorMessage("Couldn't add to cart — please try again.");
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      // Upsell cards in the cart drawer have no inline error wrapper — fall back to the
      // drawer's own error banner rather than throwing (which killed the whole flow).
      if (!this.errorMessageWrapper) {
        if (errorMessage && this.cartNotification && this.cartNotification.showError) {
          this.cartNotification.showError(errorMessage);
        }
        return;
      }
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
